import { apiV2 } from "../v2";
import {
  adminMessageIdRequest,
  adminMessageResponse,
  listAdminFeedbacksRequest,
  listAdminFeedbacksResponse,
  listAdminMessagesRequest,
  listAdminMessagesResponse,
  listAdminReportsRequest,
  listAdminReportsResponse,
  putAdminMessageRequest,
} from "./feedback.dto";

export const listAdminMessagesApi = apiV2("GET", "/admin/feedback/messages").withRequest(listAdminMessagesRequest).withResponse(listAdminMessagesResponse);

export const putAdminMessageApi = apiV2("PUT", "/admin/feedback/messages/:id").withRequest(putAdminMessageRequest).withResponse(adminMessageResponse);

export const deleteAdminMessageApi = apiV2("DELETE", "/admin/feedback/messages/:id").withRequest(adminMessageIdRequest);

export const listAdminReportsApi = apiV2("GET", "/admin/feedback/reports").withRequest(listAdminReportsRequest).withResponse(listAdminReportsResponse);

export const listAdminFeedbacksApi = apiV2("GET", "/admin/feedback/feedbacks").withRequest(listAdminFeedbacksRequest).withResponse(listAdminFeedbacksResponse);
